import { atom } from "recoil";

import { PassengerMapControlsEnum } from "../../enums";
import {
  IGetPassengersMapStationInfoPayload,
  IPassengersMapLocationInfo,
  IPassengerStationsMapInfo,
  IWarkDistanceAndTime,
  PassengersMapStationIdType,
} from "../../models";

export const passengersStationsMapLastFilterSearchAtom =
  atom<IGetPassengersMapStationInfoPayload>({
    key: "passengersStationsMapLastFilterSearchAtom",
    default: undefined,
  });

export const passengersStationsMapDataAtom = atom<IPassengerStationsMapInfo[]>({
  key: "passengersStationsMapDataAtom",
  default: [],
});

export const passengersMapCurrentPolylineViewAtom = atom<
  IWarkDistanceAndTime[]
>({
  key: "passengersMapCurrentPolylineViewAtom",
  default: [],
});

export const passengersMapSelectedControlBtnAtom = atom<
  PassengerMapControlsEnum | undefined
>({
  key: "passengersMapSelectedControlBtnAtom",
  default: undefined,
});

export const passengersMapSelectedStationDictionaryAtom = atom<
  Map<PassengersMapStationIdType, IPassengerStationsMapInfo>
>({
  key: "passengersMapSelectedStationDictionaryAtom",
  default: new Map(),
});

export const passengersMapAddStationSearchValueAtom = atom<
  IPassengersMapLocationInfo | undefined
>({
  key: "passengersMapAddStationSearchValueAtom",
  default: undefined,
});

export const passengersMapLastAddedStationIdAtom = atom<number | undefined>({
  key: "passengersMapLastAddedStationIdAtom",
  default: undefined,
});
